module.exports = __webpack_public_path__ + "static/media/QualtricsXM_Step2_Image7.20bb6560.webp";